module.exports = __webpack_public_path__ + "img/emo_05.5712da18.png";